import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=0f6038da&scoped=true&"
import script from "./ReportItem.vue?vue&type=script&lang=js&"
export * from "./ReportItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6038da",
  null
  
)

export default component.exports